import { render, staticRenderFns } from "./RoutesFeedWidget.vue?vue&type=template&id=5e18b936&"
import script from "./RoutesFeedWidget.vue?vue&type=script&lang=js&"
export * from "./RoutesFeedWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e18b936')) {
      api.createRecord('5e18b936', component.options)
    } else {
      api.reload('5e18b936', component.options)
    }
    module.hot.accept("./RoutesFeedWidget.vue?vue&type=template&id=5e18b936&", function () {
      api.rerender('5e18b936', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dynamic-list-items/widgets/feeds/RoutesFeedWidget.vue"
export default component.exports